module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('h1', {
    staticClass: "part1"
  }, [_c('a', {
    attrs: {
      "id": "page1"
    }
  }), _c('a', {
    attrs: {
      "href": "#/OEBPS/toc.htm#pro"
    }
  }, [_vm._v("PROLOGUE")])]), _vm._v(" "), _c('h1', {
    staticClass: "part2",
    attrs: {
      "id": "pro1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/toc.htm#pro1"
    }
  }, [_vm._v("FLORIDA")])]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    attrs: {
      "id": "page2"
    }
  }), _c('em', [_vm._v("It’s all wrong.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("The light winking on the blue mirror of the pool, the sun hats and the sweating beer bottles clutched in their fists. The drone of insects. The smell of warm skin slick with suntan lotion.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("All of it.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("It couldn’t really be any more unsuitable, bearing in mind what’s happening. One of them thinks there’s a word for it, for that … clash, but he can’t remember what the word is. The six of them just listen and shake their heads, trying their best not to let the woman see how awkward they’re feeling—God, that would be terrible, all things considered—but it only makes the situation worse. Now, they’re worried that they just look even more relaxed, even more insensitive. Like they don’t give a shit about the missing girl.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("It makes them all feel even guiltier.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("I mean, clearly it’s just a question of ‘context’ or whatever you call it, because for the previous thirteen days the picture could not have been more perfect. Wasn’t that exactly what they’d paid their money for, and weren’t they there to relax? But that was before the flashing lights on the roofs of cars were visible through the palm trees. Before there were cops and State Troopers running about and radios crackling.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("On top of which, the woman herself seems pretty relaxed about it all.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("‘It’s so crazy,’ she says, and raises her hands in a ‘stay where you are’ gesture when one of them tries to get up from the sunbed. ‘I feel stupid putting everyone to all this trouble.’ She takes a step away and says, ‘No, really,’ when another asks if there’s anything they can do. ‘It’s fine, honestly …’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page3"
    }
  }), _c('em', [_vm._v("Later on, talking in whispers, one of the men says, ‘Why should we feel guilty? I mean, there was no shortage of people out looking for her, and it’s not like we didn’t offer to help, is it?’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("His wife shrugs. ‘There’s not much we can do about the sunshine, is there?’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A couple of the others nod.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("‘Disparity,’ one of them says. ‘Is that the word?’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("So, they eat their final meal together and try to enjoy the last night of their holiday. They talk about how the woman’s daughter has probably just gone to the mall, if she hasn’t turned up already, and keep talking in much the same way even though the police cars are still around the following morning. On a full flight back to Gatwick, they try and fail to sleep. Scratchy-eyed, they eat their foil-wrapped meals and watch movies, and several pick at the skin that is already peeling from chests and shoulders. They stay cheerful, more or less, but each of them is thinking about the woman by the pool and a smile that quivered and died. That kept on dying, a little bit quicker each time it was cranked into place.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Thinking about her insistence that everything would be fine, that everything")]), _vm._v(" was "), _c('em', [_vm._v("fine, and the words—spoken with something approaching irritation—when she glimpsed what she took to be sympathy.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("‘She’s missing,’ the woman says. ‘That’s all, just missing. So, don’t even")]), _vm._v(" think "), _c('em', [_vm._v("it.’ And her voice rises just a little and cracks, and just before she pushes her sunglasses back into place, there’s something fierce and tight around her eyes.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("‘My daughter is not dead.’")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-661dd5c8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/pro.vue
// module id = 78
// module chunks = 0